import React from 'react';
import ContainerLayout from 'layouts/ContainerLayout';
import Contacts from 'pages/Contact/Contacts';
import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';
import { Box } from '@mui/system';

import PageHeader from '../../components/PageHeader';

import GridCards from './GridCards';

export const Home = () => {
  const { t } = useTranslation();

  return (
    <ContainerLayout>
      <Box sx={styles.boxContainer}>
        <PageHeader>{t('home.fullName')}</PageHeader>
        <Typography color='primary'>{t('home.description')}</Typography>
        <Contacts />
      </Box>
      <GridCards />
    </ContainerLayout>
  );
};

const styles = {
  boxContainer: { textAlign: 'center' },
};

export default Home;
